// extracted by mini-css-extract-plugin
module.exports = {"crossSiteLabel":"Er-z","zenCrossSiteLabel":"Fr-z","vrsnlCrossSiteLabel":"Gr-z"};